import {BelegDTO} from '../openapi/fakturierung-openapi';
import {capitalize} from '../util/capitalize';
import {isXRechnungDatei} from '../util/typeguards';


export function generateDownloadFilename(beleg?: BelegDTO): string {

  let prefix: string;
  let middle: string;
  const suffix = isXRechnungDatei(beleg) ? '.xml' : '.pdf';

  // INFO: Überprüfen, ob der Beleg eine Belegkorrektur ist
  if (beleg?.originalBelegId) {
    prefix = capitalize(beleg.belegart) + 'skorrektur_';

    // INFO: Überprüfen, ob der Beleg ein stornierter Originalbeleg ist
  } else if (beleg?.korrekturBelegId) {
    prefix = capitalize(beleg.belegart) + '_';

    // INFO: Überprüfen, ob der Beleg ein Entwurf ist
  } else if (beleg?.status.offen) {
    prefix = capitalize(beleg.belegart) + '_Entwurf_';

    // INFO: Andernfalls ist der Beleg fertiggestellt
  } else {
    prefix = capitalize(beleg ? beleg.belegart : '') + '_';
  }

  // INFO: Wenn eine Belegnummer vorhanden ist, wird diese zur Identifizierung verwendet.
  if (beleg?.nummer) {
    middle = beleg.nummer;

    // INFO: Andernfalls wird die Beleg-ID verwendet, sofern vorhanden.
  } else if (beleg?.id) {
    middle = beleg.id;

    // INFO: Andernfalls wird ein leerer String verwendet.
  } else {
    middle = '';
  }

  return `${prefix}${middle}${suffix}`;
}
